// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Q_oB","inputWrap":"styles_inputWrap__1Xqcf","input":"styles_input__3Jamd"};